var map = {
	"./shoucang.png": "38a4",
	"./shoucang1.png": "f462",
	"./shoucang2.png": "2127",
	"./shoucang3.png": "0c93",
	"./shoucang4.png": "efb4",
	"./shoucang5.png": "3b4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b93e";